import { useQuery } from '@apollo/client';
import React from 'react';
import GET_ORGS_WITH_UNITS from '../../queries/getOrgsWithUnitsQuery';
import ApolloError from '../../../../../shared/components/ApolloError';
import { OhtSelector } from './OhtSelector';
import { PAGE_MODE } from '../../../../constants/pageModeTypes';
import { OrgOrgUnitSelectors } from '../../../../../shared/components/inputs/OrgOrgUnitSelectors';
import { OrgUnitSelector } from '../../../../../shared/components/inputs/OrgUnitSelector';
import useOhtList from '@shared/hooks/useOhtList';

/**
 * @typedef {object} PermissionListsProps
 * @property {Object} [permissions]
 * @property {(permissions: Object | ((prev: Object) => Object)) => void} setPermissions
 * @property {boolean} [disabled]
 * @property {number} pageMode
 * @property {number} [orgId]
 * @property {boolean} [isUserRoleSelected]
 */

/**
 * @param {PermissionListsProps} props
 */
export const PermissionLists = props => {
  const { permissions, setPermissions, disabled, pageMode, orgId, isUserRoleSelected } = props;

  const {
    data: orgsData,
    loading: orgsLoading,
    error: orgsError
  } = useQuery(GET_ORGS_WITH_UNITS, {
    variables: {
      orgId: pageMode === PAGE_MODE.MddapOrg ? orgId : null
    }
  });

  const { ohtList, ohtListLoading, ohtListError } = useOhtList(pageMode === PAGE_MODE.MddapOrg);

  const organizations = orgsData ? orgsData.orgsWithUnits : [];

  if (orgsError || ohtListError) {
    return <ApolloError />;
  }

  if (pageMode === PAGE_MODE.MddapOrg) {
    return (
      <div className='license-page__section org-unit-list'>
        <h4 className='field-title'>Units</h4>
        <OrgUnitSelector
          organizations={organizations.filter(o => o.Id === orgId)}
          value={permissions.orgUnitIds}
          onChange={orgUnitIds => setPermissions({ ...permissions, orgUnitIds: orgUnitIds })}
          disabled={!isUserRoleSelected || disabled}
          loading={orgsLoading}
        />
      </div>
    );
  }

  return (
    <>
      <h4 className='field-title'>Permissions</h4>
      <div className='permission-list'>
        <OrgOrgUnitSelectors
          organizations={organizations}
          sectionClassName='license-page__section'
          orgSelectorProps={{
            value: permissions.orgIds,
            onChange: orgIds =>
              setPermissions(prevState => ({
                ...prevState,
                orgIds
              }))
          }}
          orgUnitSelectorProps={{
            value: permissions.orgUnitIds,
            onChange: orgUnitIds =>
              setPermissions(prevState => ({
                ...prevState,
                orgUnitIds
              }))
          }}
          loading={orgsLoading}
          disabled={disabled}
        />
        <div className='license-page__section'>
          <OhtSelector
            ohts={ohtList}
            selectedOhtIds={permissions.ohts}
            setSelectedOhts={selection => setPermissions({ ...permissions, ohts: selection })}
            disabled={disabled}
            loading={ohtListLoading}
          />
        </div>
      </div>
    </>
  );
};

export default PermissionLists;
